/** @jsxImportSource theme-ui @jsxRuntime classic */

import { H } from '@hzdg/sectioning';
import React, { Fragment } from 'react';
import { Container, Box, Text, Link } from '@tishman/components';

export interface ShareYourExperienceBlockHeaderProps {
  title?: string;
  hashTags?: string[];
}

const ShareYourExperienceBlockHeader = ({
  title = 'How was your view from Top of the Rock? Share your experience!',
  hashTags,
}: ShareYourExperienceBlockHeaderProps): JSX.Element => (
  <Container
    data-module="ShareYourExperienceBlockHeader"
    sx={{ maxWidth: 625 }}
  >
    <H
      sx={{
        variant: 'text.mediumTitle',
        mb: 3,
      }}
    >
      {title}
    </H>
    {hashTags && (
      <Box>
        <Box>
          {hashTags.length > 0 && (
            <Text as="span" variant="mediumP">
              {'Use '}
            </Text>
          )}
          {hashTags.map((hashTag, i) => {
            const lastTag = i === hashTags.length - 1;
            const secondLastTag = i === hashTags.length - 2;
            const onlyTag = hashTags.length === 1;

            return (
              <Fragment key={hashTag}>
                {!onlyTag && lastTag && (
                  <Text as="span" variant="mediumP">
                    {'or '}
                  </Text>
                )}
                <Link
                  href={`https://www.instagram.com/explore/tags/${hashTag.replace(
                    '#',
                    '',
                  )}/`}
                  sx={{ variant: 'text.mediumP' }}
                  target="_blank"
                >
                  {hashTag}
                </Link>
                <Text as="span" variant="mediumP">
                  {lastTag ? '.' : secondLastTag ? ' ' : ', '}
                </Text>
              </Fragment>
            );
          })}
        </Box>
      </Box>
    )}
  </Container>
);

export default ShareYourExperienceBlockHeader;
